var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFollowStar = function SvgFollowStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a5 5 0 1 1 10 0A5 5 0 0 1 3 5m5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20c0-4.402 3.09-9 8.5-9 1.12 0 2.157.201 3.094.57l-.73 1.86A6.4 6.4 0 0 0 8.5 13C4.473 13 2 16.402 2 20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.187 11.555a1.1 1.1 0 0 0-1.815 0l-1.303 1.902-2.212.652a1.1 1.1 0 0 0-.56 1.726l1.405 1.827-.063 2.305a1.1 1.1 0 0 0 1.468 1.067l2.172-.773 2.173.773a1.1 1.1 0 0 0 1.468-1.067l-.063-2.305 1.406-1.827a1.1 1.1 0 0 0-.56-1.726l-2.213-.652zm-1.87 3.62.962-1.406.964 1.405 1.634.482-1.039 1.35.047 1.703-1.606-.57-1.605.57.047-1.703-1.039-1.35z",
    clipRule: "evenodd"
  })));
};
export default SvgFollowStar;